<template>
  <div class="flex">
    <div class="flex flex-col justify-center mr-2" v-if="showPill">
      <div class="flex bg-blue-300 py-1 pr-3 border border-solid border-transparent rounded-full h-7 select-none cursor-pointer">
        <div 
          class="flex justify-items-center items-center" 
          @click="showPill = false" 
          data-testid='widget-close-btn'
        >
          <Icon 
            icon="x" 
            color="white" 
            size="xs"
            class="mr-2 flex ml-3"
          />
        </div>
        <div class="flex items-center cursor-pointer justify-items-center">
          <span 
            class="m-0 font-medium whitespace-no-wrap ds-text-xs text-white"
            data-testid='widget-cta'
            @click="scheduleCall"
          >Need Help? Schedule a call</span>
        </div>
      </div>
    </div>
    <div 
      class="flex flex-col justify-end cursor-pointer" @click="scheduleCall">
      <PAvatar 
        size="md" 
        type="icon" 
        image="sr-2 sr-v2-question-mark-circle"
        color="blue"
      />
    </div>
  </div>
</template>

<script>
import tracking from "../utils/tracking";
import { PAvatar, Icon } from '@sportsrecruits/playbook'
export default {
  components: {
    PAvatar,
    Icon
  },
  data: () => ({
    showPill: true
  }),
  methods: {
    scheduleCall() {
      tracking.calendly('https://calendly.com/sr-insights/sportsrecruits-memberships-learn-more',
        {
          event: 'clicked_schedule_call',
          cta_location: 'schedule_call_bottom',
        });
    },
  }
};
</script>

<style>
</style>
